"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    version: "0.4",
    cacheApiUrl: "https://api.redstone.finance/prices",
    // cacheApiUrl: "https://api.redstone.finance/b1/prices",
    // cacheApiUrl: "https://api.redstone.finance/b2/prices",
};
